import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { removeMedia } from '../client/ApiClient';
import { CDN_TRAIN_ENDPOINT } from '../constants';

@customElement('media-grid')
export class MediaGrid extends LitElement {
  createRenderRoot() {
    return this;
  }

  @property({ type: Array }) mediaIds: string[] = [];
  @property({ type: String }) slug = '';
  @property({ type: Boolean }) isPrimary = false;

  @state() selected: string | null = null;
  @state() working = false;

  async handleDelete(id: string) {
    if (!confirm('Remove this media?')) return;
    this.working = true;
    try {
      await removeMedia(this.slug, id, this.isPrimary);
      this.mediaIds = this.mediaIds.filter((mid) => mid !== id);
      this.dispatchEvent(new CustomEvent('media-removed', { bubbles: true }));
    } catch (err) {
      alert('Failed to remove media: ' + err.message);
    } finally {
      this.working = false;
    }
  }

  render() {
    return html`
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        ${this.mediaIds.map(id => html`
          <div class="relative group">
            <img
              src="${CDN_TRAIN_ENDPOINT}/${id}"
              class="rounded cursor-pointer max-h-48 object-cover w-full"
              @click=${() => this.selected = id}
            />
            <button
              class="btn btn-xs btn-error absolute top-1 right-1 opacity-0 group-hover:opacity-100"
              @click=${() => this.handleDelete(id)}
              ?disabled=${this.working}
            >
              ✕
            </button>
          </div>
        `)}
      </div>

      ${this.selected ? html`
        <dialog class="modal modal-open" @click=${() => this.selected = null}>
          <div class="modal-box max-w-5xl p-4">
            <img
              src="${CDN_TRAIN_ENDPOINT}/${this.selected}"
              class="max-h-[80vh] mx-auto rounded"
              @click=${(e: Event) => e.stopPropagation()}
            />
            <form method="dialog" class="modal-backdrop">
              <button>close</button>
            </form>
          </div>
        </dialog>
      ` : ''}
    `;
  }
}

